/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Optional minimum duration (minutes) allowed for slot-level overrides.
 */
export type EventKindMinDurationMin = number | null;
